import OpenEndedActivityContent from "../../../components/common/activities/OpenEndedActivityContent";

export default OpenEndedActivityContent;
